import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import {deliveryTrendChart} from "../../../../constant/charts";
import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDeliveryTrend } from "../../../../redux/action/Stats";
import { getTopMode } from "../../../../utils";
import EmptyStats from "../../../common/components/EmptyStats";
import { BarChart3 } from "lucide-react";


ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);


export default function MyChart() {
  const [type, setType] = useState("lastThreeMonth");
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.GET_DELIVERY_TREND);

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  const getDeliveryTrendData = useCallback(() => {
    let payload = {};
    if (type === "currentWeek") {
      payload = JSON.stringify({ currentWeek: true });
    } else if (type === "currentMonth") {
      payload = JSON.stringify({ currentMonth: true });
    } else if (type === "lastThreeMonth") {
      payload = JSON.stringify({ lastThreeMonth: true });
    }
    dispatch(getDeliveryTrend(payload));
  }, [dispatch, type]);

  useEffect(() => {
    getDeliveryTrendData();
  }, [getDeliveryTrendData]);

  const transformChartData = (apiData) => {
    const labels = apiData.map((item) => item.date);
    const videoData = apiData.map((item) => item.video || 0);
    const chatData = apiData.map((item) => item.chat || 0);
    const audioData = apiData.map((item) => item.audio || 0);
    const inPersonData = apiData.map((item) => item.inPerson || 0);

    return {
      labels,
      datasets: [
        {
          label: "Video",
          data: videoData,
          backgroundColor: "#D5E862",
          categoryPercentage: 0.3,
          barPercentage: 0.5,
          barThickness: 15,
          borderRadius: 6,
        },
        {
          label: "Chat",
          data: chatData,
          backgroundColor: "#DB62E8",
          categoryPercentage: 0.3,
          barPercentage: 0.5,
          barThickness: 15,
          borderRadius: 6,
        },
        {
          label: "Audio",
          data: audioData,
          backgroundColor: "#2563EB",
          categoryPercentage: 0.3,
          barPercentage: 0.5,
          barThickness: 15,
          borderRadius: 6,
        },
        {
          label: "In-person",
          data: inPersonData,
          backgroundColor: "#FFAF77",
          categoryPercentage: 0.3,
          barPercentage: 0.5,
          barThickness: 15,
          borderRadius: 6,
        },
      ],
    };
  };

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const chartData = transformChartData(data);
      setChartData(chartData);
    } else {
      // fallback to empty chart if no data
      setChartData({ labels: [], datasets: [] });
    }
  }, [data]);

  return (
    <div className="bg-white rounded-2xl p-[24px] border-[1px] border-solid border-[#E2E8F0] shadow-sm w-full h-full flex flex-col min-h-[450px]">
      <div className="flex flex-wrap justify-between items-center gap-2 -mx-[24px] -mt-[24px] px-[24px] py-[14px] bg-[#E7EDF5] rounded-t-[15px]">
        <div className="flex items-center gap-2.5">
          <div className="flex items-center justify-center w-[36px] h-[36px] rounded-xl bg-white text-[#2563EB] flex-shrink-0">
            <BarChart3 size={18} />
          </div>
          <h2 className="text-base font-semibold text-[#171717] font-poppins mb-0">
            Appointments Trend
          </h2>
        </div>

        <div className="flex items-center justify-center gap-2">
          <div className="flex justify-center items-center bg-white py-1 px-3 rounded-full">
            <span className="text-xs text-[#334155] font-normal font-poppins">
              Top Mode{" "}
              <span className="font-semibold text-[#2563EB]">
                {getTopMode(data) === "No_Mode" ? "--" : getTopMode(data)}
              </span>
            </span>
          </div>

          <div className="relative inline-block">
            <select
              className="border-[1px] border-solid border-[#E2E8F0] font-poppins text-xs rounded-xl pl-[12px] pr-[34px] py-[6px] appearance-none bg-white text-[#2563EB] font-medium cursor-pointer hover:border-[#CBD5E1]"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value={"currentWeek"}>This Week</option>
              <option value={"currentMonth"}>This Month</option>
              <option value={"lastThreeMonth"}>3 Month</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-2.5 flex items-center">
              <svg
                className="w-3.5 h-3.5 text-[#2563EB]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 flex flex-col w-full min-h-[340px]">
        <div className="mt-4" />
        {loading && (
          <div className="text-center text-gray-500 mt-20">Loading...</div>
        )}
        {!loading &&
        Array.isArray(data) &&
        getTopMode(data) !== "No_Mode" &&
        chartData.datasets.length > 0 ? (
          <div className="relative flex-1 min-h-0">
            <Bar options={deliveryTrendChart} data={chartData} />
          </div>
        ) : (
          !loading && <EmptyStats />
        )}
      </div>
    </div>
  );
}